/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LicensesCollapsedSectionFragment } from "@cosmos/hygraph-schema";

import {
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
	BackgroundContainer,
	LicenseTopCard,
	CosmosText,
	CosmosTextVariantEnum,
} from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { LicensesCollapsedCards } from "./LicensesCollapsedCards.organism";

export function LicensesCollapsedSection({
	config,
	topCard,
	collapsedCardsHeading,
	collapsedCards,
	collapsedCta,
	freeHeading,
}: LicensesCollapsedSectionFragment): React.JSX.Element | null {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(
		topCard?.title ||
			topCard?.bullets?.length ||
			topCard?.checkList ||
			topCard?.buttons?.length ||
			collapsedCardsHeading ||
			collapsedCards?.length ||
			collapsedCta ||
			freeHeading,
	);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
			bgBlur
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack
						gap="eds.dimension.48"
						alignItems="stretch"
						className={cx("license-cards-collapsed-section", css({ smDown: { gap: "eds.dimension.40" } }))}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<>
								<VStack
									gap="eds.dimension.48"
									alignItems="stretch"
									className={css({ smDown: { gap: "eds.dimension.40" } })}
								>
									<VStack alignItems="flex-start" gap="eds.dimension.24">
										<CosmosText
											variant={CosmosTextVariantEnum.headingLG}
											as={config?.heading?.title ? "h3" : "h2"}
											text={freeHeading || ""}
										/>
										<LicenseTopCard
											title={topCard?.title}
											titleAs={config?.heading?.title ? "h4" : "h3"}
											bullets={topCard?.bullets || []}
											checkList={topCard?.checkList || []}
											buttons={topCard?.buttons || []}
										/>
									</VStack>
								</VStack>
								<LicensesCollapsedCards heading={collapsedCardsHeading} cards={collapsedCards} cta={collapsedCta} />
							</>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
}
